'use strict';

import React from 'react';
import ThumbnailSlider from './thumbnailSlider'

class Thumbnail extends React.Component {

  render () {
    const { thumbnailImage, thumbnailId, handleThumbnailOnClick, ...otherProps } = this.props;
    return (
      <div className="Thumbnail">
        <div className="ThumbnailContainer">
          <img className="thumbnail-image" src={thumbnailImage} onClick={handleThumbnailOnClick}/>
          <div className="GradientOverlay p-absolute"></div>
          <ThumbnailSlider {...otherProps}/>
        </div>
        <div className="ThumbnailInfo">
          Video ID: { thumbnailId }
        </div>
      </div>
    );
  }
}

export default Thumbnail;



// WEBPACK FOOTER //
// ./src/components/clarity-ui/components/thumbnail/thumbnail.jsx